import {
  SpedDocumentStatus,
  SpedDocumentStatusLabel,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import { Select, SelectProps } from 'antd';

export default function SpedDocumentStatusSelect(
  props: Omit<SelectProps, 'options'>,
) {
  const options = Object.values(SpedDocumentStatus).map((value) => ({
    value,
    label: SpedDocumentStatusLabel[value],
  }));

  return (
    <Select
      {...props}
      style={{ width: '100%', ...props.style }}
      options={options}
    />
  );
}
